export enum QuestionTypes {
  MULTIPLE_CHOICE = 'MultipleChoice',
  MULTIPLE_RESPONSE = 'MultipleResponse',
  BOOLEAN = 'TrueOrFalse',
  SEQUENCE = 'Sequence',
}
